<template lang="html">
	<section class="simulator">

		<div class="row">
			<div class="center col">
				<h3 class="content-title">{{ trans.get('simulator.title') }}</h3>
				<p class="simulator-reduction">{{result | pointNumber}} €</p>
			</div>
		</div>

		<div class="row">
			<div class="col col-md-4 col-12">
				<h3 class="content-title" v-html="trans.get('simulator.resto-title')"></h3>
				<h5>{{ trans.get('simulator.resto-sub') }}</h5>
				<h1>{{ restVal }}</h1>
				<vue-slider ref="slider1" v-model="restVal" height="13" :min="3" :max="20" :tooltip="'none'" :dotSize="25"></vue-slider>
			</div>

			<div class="col col-md-4 col-12">
				<h3 class="content-title" v-html="trans.get('simulator.people-title')"></h3>
				<h5>{{ trans.get('simulator.people-sub') }}</h5>
				<h1>{{ persVal }}</h1>
				<vue-slider ref="slider2" v-model="persVal" height="13" :min="1" :max="15" :tooltip="'none'" :dotSize="25"></vue-slider>
			</div>

			<div class="col col-md-4 col-12">
				<h3 class="content-title" v-html="trans.get('simulator.budget-title')"></h3>
				<h5>{{ trans.get('simulator.budget-sub') }}</h5>
				<h1>{{ budgetVal }} €</h1>
				<vue-slider ref="slider3" v-model="budgetVal" height="13" :min="10" :max="80" :tooltip="'none'" :dotSize="25"></vue-slider>
			</div>
		</div>

	</section>
</template>

<script>
import vueSlider from 'vue-slider-component';
import Lang from 'lang.js';
import translations from '../vue-translations'

export default {

	components: {vueSlider},

	props: ['langsite'],

	data() {
		return{
			trans: null,
			restVal: 5,
			persVal: 4,
			budgetVal: 25,
		}
	},

	beforeMount(){
		// Localization
		const lang = new Lang()
		this.trans = lang
		this.trans.setLocale(this.langsite)
		this.trans.setMessages(translations)
	},

	mounted(){

		this.result

	},

	computed: {

		result() {
			let res = ((this.restVal * this.persVal * this.budgetVal) / 100) * 30
			return res.toFixed(0)
		},

	},

	filters: {

		pointNumber(val) {
			val = val.toString();
			if(val.length > 3){
				val = [val.slice(0, 1), '.', val.slice(1)].join('');
			}
			return val;
		}

	}

}
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/simulator.vue